import en_US from '../../date-picker/locale/en_US';
export default en_US;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_antd@4.1.3@antd/es/calendar/locale/en_US.js
// module id = 459
// module chunks = 0